export default __webpack_public_path__ + "static/media/spain.c82f2a10.svg";